<template>
<div class="CommandList">
    <div class="table-container">
        <el-table :data="tableData">
            <el-table-column width="60" label="ID" prop='id'/>

            <el-table-column width="160" :label="$t(/*创建时间*/'c.create_time')">
                <template slot-scope="{row}">{{$U.timeFormat(row.create_time)}}</template>
            </el-table-column>
            <el-table-column width="100" :label="$t(/*状态*/'c.status')">
                <template slot-scope="{row}">{{$t($U.commandStatusFilter(row))}}</template>
            </el-table-column>

            <el-table-column width="180" :label="$t(/*请求类型*/'command.request_type')">
                <template slot-scope="{row}">{{$t($U.commandTypeFilter(row.type))}}</template>
            </el-table-column>
            <el-table-column width="100" :label="$t(/*请求ID*/'command.request_id')" prop='request_id'/>
            <el-table-column width="160" :label="$t(/*发送时间*/'command.request_time')">
                <template slot-scope="{row}">{{$U.timeFormat(row.request_time)}}</template>
            </el-table-column>
            <el-table-column width="120" :label="$t(/*请求数据*/'command.request_data')">
                <template slot-scope="{row}">
                    <el-button type="text" @click="handleDialogShow('request', row.request_data)">{{$t(/*查看*/'c.view')}}</el-button>
                </template>
            </el-table-column>

            <el-table-column width="160" :label="$t(/*回应时间*/'command.response_time')">
                <template slot-scope="{row}">{{$U.timeFormat(row.response_time)}}</template>
            </el-table-column>
            <el-table-column width="120" :label="$t(/*回应数据*/'command.response_data')">
                <template slot-scope="{row}">
                    <el-button type="text" @click="handleDialogShow('response', row.response_data)">{{$t(/*查看*/'c.view')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="paging-container with-btn">
        <el-button @click="pageChange(1)">{{$t(/*刷新*/'c.refresh')}}</el-button>
        <el-pagination
            @current-change="pageChange"
            :current-page="currPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <el-dialog :title="dialogType === 'request' ? $t(/*请求数据*/'command.request_data') : $t(/*回应数据*/'command.response_data')"
        :visible.sync="dialogVisible" custom-class="json-dialog" width="600px">
        <div class="content">
            <div class="pre-warp"><pre>{{jsonData}}</pre></div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import Core from '../../../core'
const {arrayBufferToString, hexToArrayBuffer} = Core.Util

export default {
    components: {},
    props: {
        uid: { type: [String] },
        id:  { type: [String, Number] },
        space: { type: [String, Number] },
        detail: { type: Object, default: () => {}},
    },
    data() {
        return {
            tableData: [],
            currPage: 1,
            pageSize: 10,
            total: 0,

            dialogVisible: false,
            dialogType: '',
            jsonData: '',
        }
    },
    watch: {},
    computed: {},
    mounted() {
        this.pageChange(1)
    },
    methods: {
        getTableData() {
            let apiName = 'Fengine' + this.space
            Core.Api[apiName].getCommandList({
                page: this.currPage,
                id: this.uid
            }).then(res => {
                this.tableData = res.command_list
                this.total = res.count;
            });
        },
        pageChange(page) {
            this.currPage = page;
            this.getTableData();
        },

        handleDialogShow(type, data) {
            this.dialogType = type
            switch (type) {
                case 'request':
                    this.jsonData = data
                    break;
                case 'response':
                    if (!data) {
                        return this.$message.info($t(/*暂无回应数据*/'command.response_empty'))
                    }
                    this.jsonData = arrayBufferToString(hexToArrayBuffer(data));
                    break;
            }
            this.dialogVisible = true;
        },
    },
}
</script>

<style lang='scss' scoped>
// .CommandList {}
</style>